const TRAILING_DECIMAL_ZEROS_REGEX = /\.?0+$/;

export function trimTrailingDecimalZeroes(num: string) {
	return num.includes(".")
		? num.replace(TRAILING_DECIMAL_ZEROS_REGEX, "")
		: num;
}

export function addDecimalPoint(price: string, decimals = 0) {
	if (decimals === 0) {
		return price;
	}

	const isNegative = price.startsWith("-");
	const absPrice = isNegative ? price.slice(1) : price;

	if (absPrice.length <= decimals) {
		const zerosNeeded = decimals - absPrice.length;
		const paddedPrice = "0".repeat(zerosNeeded) + absPrice;
		return `${isNegative ? "-" : ""}0.${paddedPrice}`;
	}

	const priceBeforeDecimal = absPrice.slice(0, -decimals);
	const priceAfterDecimal = absPrice.slice(-decimals);
	return `${isNegative ? "-" : ""}${priceBeforeDecimal}.${priceAfterDecimal}`;
}
